/** Load the editable draft before optional ticket siblings, avoiding an undefined-ticket request. */
export async function loadDeclarationForEditor({ id, getById, getByTicket, normalize, onDraft, onSiblings, onSiblingsError }) {
  const response = await getById(id);
  if (!response?.data?.id) throw new Error("Declaration not found");
  const draft = normalize(response.data);
  onDraft(draft);
  onSiblings([draft]);
  if (!draft.ticketId) return;
  try {
    const response = await getByTicket(draft.ticketId);
    const others = (Array.isArray(response.data) ? response.data : []).filter((item) => item.id !== draft.id).map(normalize);
    onSiblings([draft, ...others]);
  } catch (error) { onSiblingsError(error); }
}

/** Per-editor catalog cache: coalesce parallel requests and prevent stale country responses. */
export function createCountryCitiesLoader(fetchCities, batch = (update) => update()) {
  const entries = new Map();
  const selectedCountry = new Map();
  const load = (country, setCities) => {
    selectedCountry.set(setCities, country);
    if (!country) { setCities([]); return Promise.resolve(); }
    let entry = entries.get(country);
    if (!entry) {
      entry = { subscribers: new Set(), data: null };
      entries.set(country, entry);
      entry.promise = Promise.resolve().then(() => fetchCities(country)).then((response) => {
        entry.data = response.data;
        batch(() => entry.subscribers.forEach((setter) => { if (selectedCountry.get(setter) === country) setter(entry.data); }));
        entry.subscribers.clear();
      }).catch((error) => { entries.delete(country); throw error; });
    }
    if (entry.data !== null) {
      batch(() => setCities(entry.data));
      return Promise.resolve();
    }
    entry.subscribers.add(setCities);
    return entry.promise;
  };
  load.clear = () => { selectedCountry.clear(); entries.clear(); };
  return load;
}
